import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import UserForm from './UserForm';
import ChatScreen from './ChatScreen';
import { StartChatResponse } from '../../Model/Response/ClientUser/StartChatResponse';
import { GetServiceDetailResponse } from '../../Model/Response/MusteriKurumTanim/GetServiceDetailResponse';
import { GetServiceDetailRequest } from '../../Model/Request/MusteriKurumTanim/GetServiceDetailRequest';
import { ApiBaseResponse, ResponseCode } from '../../Model/Response/Common/ApiBaseResponse';
import { GetServiceDetail } from '../../Controller/Api/MusteriKurumTanimController'; 

const WebChatPage: React.FC = () => {
    const [isChatActive, setIsChatActive] = useState(false);
    const [messages, setMessages] = useState<StartChatResponse | null>(null);
    const [serviceDetail, setServiceDetail] = useState<GetServiceDetailResponse | null>(null);
    const [isWorkingTime, setIsWorkingTime] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(true);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const { lang } = useParams<{ lang: string }>();
    const query = new URLSearchParams(useLocation().search);
    const hId = query.get('hId');
    const guid = query.get('guid');

    useEffect(() => {
        const fetchServiceDetail = async () => {
            if (!hId || !guid) {
                setErrorMessage('Gerekli parametreler eksik');
                setLoading(false);
                return;
            }

            const request: GetServiceDetailRequest = {
                serviceId: Number(hId),
                serviceGuid: guid
            };

            try {
                let response: ApiBaseResponse<GetServiceDetailResponse> | null = await GetServiceDetail(request);

                if (response == null || response.content == null || response.responseCode !== ResponseCode.OK) {
                    setErrorMessage(response?.text || 'Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.');
                    setLoading(false);
                    return;
                }

                setServiceDetail(response.content);
                setIsWorkingTime(response.content.isDigitalAgentAtWorkingTime);
                document.title = response.content.clientName;

                if (!response.content.isDigitalAgentAtWorkingTime) {
                    setErrorMessage(response.content.digitalAgentOutOfWorkingTimeMessage || 'Çalışma saati dışında.');
                }
            } catch (error) {
                console.error('API hatası:', error);
                setErrorMessage('Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.');
            } finally {
                setLoading(false);
            }
        };

        fetchServiceDetail();
    }, [hId, guid]);

    const handleFormSubmit = async (chatResponse: StartChatResponse) => {
        setMessages(chatResponse);
        setIsChatActive(true);
    };

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: 'white'
            }}>
                <h1>Yükleniyor...</h1>
            </div>
        );
    }

    if (errorMessage) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: 'white',
                textAlign: 'center',
                padding: '20px'
            }}>
               <h1 dangerouslySetInnerHTML={{ __html: errorMessage.replace(/\n/g, '<br />') }} />
            </div>
        );
    }

    return (
        <div style={{ padding: '20px', width: '24rem', height: '38rem', margin: '0 auto' }}>
            {!isChatActive ? (
                <UserForm onSubmit={handleFormSubmit} serviceDetail={serviceDetail} />
            ) : (
                <ChatScreen chatStart={messages} />
            )}
        </div>
    );
};

 
export default WebChatPage;
